import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2'

/** 获取未完成拼版工单列表 */
export const getNoAssemblyWorkOrderList= (params) => {
  return axios.post(`${rootApi}/production/mosaicWorkOrder/unCompletedMosaicWorkOrderList`,params,{dataType:'json'})
}

/** 获取已完成拼版工单列表 */
export const getAssemblyWorkOrderList= (params) => {
  return axios.post(`${rootApi}/production/mosaicWorkOrder/completedMosaicWorkOrderList`,params,{dataType:'json'})
}

/** 获取拼版工单子工单列表 */
// export const getSubWorkOrderList= (assemblyWorkOrderId) => {
//   return axios.get(`${rootApi}/production/mosaicWorkOrder/mosaicChildWorkOrderList/${assemblyWorkOrderId}`)
// }

/** 获取物料清单 */
export const getWorkOrderListByParent= (params) => {
  return axios.get(`${rootApi}/production/workOrderForMosaic/getWorkOrderListByParentId`,{params})
}

/** 报工 */
export const massReportWork= (params) => {
  return axios.post(`${rootApi}/production/workOrderForMosaic/workOrderReport`,params)
}